module.exports = __webpack_public_path__ + "static/media/Asset1.4c9432af.png";